/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum EditType {
  edit,
  remove,
  add,
  resetPassword
}
